export const API_TOKEN_SCOPES = [
  "websites:read", "websites:write", "databases:read", "databases:write", "domains:read", "mail:read", "mail:write", "migrations:read", "migrations:write",
] as const;
export type ApiTokenScope = (typeof API_TOKEN_SCOPES)[number];

export interface ApiTokenRecord {
  id: string;
  name: string;
  prefix: string;
  scopes: ApiTokenScope[];
  expiresAt: string;
  status: "ACTIVE" | "EXPIRED" | "REVOKED";
  lastUsedAt: string | null;
  createdAt: string;
}

export interface CreatedApiToken extends ApiTokenRecord {
  /** Shown once. HostDock keeps only a hash and cannot show it again. */
  token: string;
}

export const WEBHOOK_EVENT_TYPES = [
  "website.created", "website.failed", "migration.completed", "migration.completed_with_warnings", "migration.failed", "migration.cancelled",
  "mailbox.created", "mailbox.deleted", "backup.completed", "backup.failed", "webhook.test",
] as const;

export interface WebhookEndpointRecord {
  id: string;
  url: string;
  description: string;
  events: string[];
  status: "ACTIVE" | "DISABLED";
  disabledReason: string | null;
  consecutiveFailures: number;
  createdAt: string;
}

export interface CreatedWebhookEndpoint extends WebhookEndpointRecord {
  /** Signing secret, shown once. */
  secret: string;
}

export interface WebhookDeliveryRecord {
  id: string;
  eventType: string;
  status: "PENDING" | "SUCCESS" | "FAILED";
  attempts: number;
  nextAttemptAt: string | null;
  lastStatusCode: number | null;
  lastError: string | null;
  lastDurationMs: number | null;
  createdAt: string;
  deliveredAt: string | null;
}
